import { connect } from "react-redux";
import { All, Query } from "../interfaces";
import { Dispatch } from "react";
import * as actions from "../common/actions";
import BankFindSearchForm from "../components/BankFind/BankFindSearchForm";

function mapStateToProps({ appState }: All) {
  return {
    appState: appState.bankFind,
  };
}
function mapDispatchToProps(dispatch: Dispatch<actions.AllActions>) {
  return {
    resetState: (state: Query) => {
      dispatch(actions.resetState(state));
    },
  };
}
export default connect(mapStateToProps, mapDispatchToProps)(BankFindSearchForm);
